import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

class UiSelect extends Component {

  static propTypes = {
    type: PropTypes.number,
    selectItems: PropTypes.array.isRequired,
    itemClick: PropTypes.func,
    valueText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    value: PropTypes.any,
    withCheckboxes: PropTypes.bool,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWrapperBlur);
  }

  handleToggleDropdown = () => {
    this.setState({
      toggle: !this.state.toggle
    }, () => {
      setTimeout(() => {
        this.state.toggle
          ? window.addEventListener('click', this.handleWrapperBlur)
          : window.removeEventListener('click', this.handleWrapperBlur)
      }, 0)
    })
  };

  handleItemClick = (selectItem) => {
    this.handleToggleDropdown();
    this.props.itemClick(selectItem);
  };

  handleWrapperBlur = (e) => {
    const disallowClasses = [".ui-checkbox, .ui-checkbox__label", ".ui-select2__dropdown",
      ".ui-select2__dropdown-back", ".ui-select2__dropdown-list-item", ".ui-select__dropdown",
      ".ui-select__dropdown-back", ".ui-select__dropdown-list-item"];
    if (this.state.toggle && !disallowClasses.some(cls => e.target.closest(cls))) {
      this.handleToggleDropdown();
    }
  };

  getSelectText = (itemText) => {
    switch (itemText) {
      case "4in":
      case "6in":
      case "18in":
      case "Full":
        return <FormattedMessage id={"quotingTool.backsplashSelect.height." + itemText}/>
      default:
        return itemText
    }
  };

  render() {

    const baseClass = this.props.type === 1 ? "ui-select" : "ui-select"+this.props.type;
    const dropDownStyles = this.state.toggle
      ? { height: this.props.selectItems.length * (this.props.withCheckboxes ? 40 : 34)}
      : {};

    return (
      <div className={baseClass + (this.state.toggle ? ` ${baseClass}--opened` : "") + ` ${baseClass}--left-aligned `
      + (this.props.className || "")}>
        <div className={baseClass+"__input"} onClick={this.handleToggleDropdown}>
          <span className={baseClass+"__input-label"}>{this.props.valueText}</span>
          {this.props.value ? (
            <span className={baseClass+"__input-value"}>{this.getSelectText(this.props.value)}</span>
          ) : null}
        </div>
        <div className={baseClass+"__dropdown "
        + (this.props.withCheckboxes ? baseClass+"__dropdown--with-checkboxes" : "")} style={dropDownStyles}>
          <ul className={baseClass+"__dropdown-list"}>
            {this.props.children || this.props.selectItems.map((selectItem, index) => {
              return (
                <li key={"dropdownRelated"+index}
                    data-index={index}
                    onClick={() => this.handleItemClick(selectItem)}
                    className={baseClass+"__dropdown-list-item"}>
                  {this.getSelectText(selectItem.text || selectItem)}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
})(UiSelect);
